<template>
    <v-card elevation="0" style="min-height: 80vh;">
        <!-- <v-col cols="12" style="height: 100%;"> -->
        <v-card elevation="0" style="margin-top: 15px;">
            <v-card-title>
                {{ $t('_visualiser_les_donnees_') }}
            </v-card-title>
        </v-card>
        <v-card style="height: 80vh;">
            <v-row>
                <v-col clos="9">
                    <div class="container">
                        <div class="mapContainer">
                            <l-map ref="refMap" class="small-map" :zoom="zoom" :center="center"
                                @update:zoom="zoomUpdated" @update:center="centerUpdated"
                                @update:bounds="boundsUpdated">

                                <custom-tile-layer :url="tileProviders.url" :attribution="tileProviders.attribution"
                                    :maxZoom="22" :maxNativeZoom="18" />
                                <l-feature-group ref="featureGroup" />

                            </l-map>
                        </div>
                    </div>
                </v-col>
                <v-col cols="3" style="justify-content: center; margin: 15px">
                    <div style="display: grid;">
                        <div> Données à afficher: </div>
                        <select class="createSelect" v-model="typeDonnes">
                            <option v-for="(donnee, index) in datas" :key="index" :value="index"> {{ donnee.name }} 
                            </option>
                        </select>
                        <div> Légende : </div>
                        <div v-if="typeDonnes!== -1">
                        <div v-for="(seuil, index) in datas[typeDonnes].levels" :key="index"
                            style="display: inline-flex; margin-bottom: 5px; width: 100%;">
                            <div
                                :style="{ width: '35px', height: '25px', backgroundColor: seuil.couleur, border: '1px solid black' }">
                            </div>
                            <div>{{ seuil.name }}</div>
                        </div>
                        </div>
                        <div style="display: inline-flex;">
                            <div
                                :style="{ width: '35px', height: '25px', backgroundColor: '#FFFFFF', border: '1px solid black' }">
                            </div>
                            <div>Non assigné</div>
                        </div>
                    </div>
                </v-col>
            </v-row>

        </v-card>
    </v-card>

</template>

<script>
import { LMap, LFeatureGroup } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import 'leaflet.locatecontrol';
import api from "@/api/api";
import backend from '@/api/backend';

const CustomTileLayer = {
    name: 'CustomTileLayer',
    props: ['url', 'attribution', 'maxZoom', 'maxNativeZoom'],
    mounted() {
        const tileLayer = L.tileLayer(this.url, {
            attribution: this.attribution,
            maxZoom: this.maxZoom,
            maxNativeZoom: this.maxNativeZoom,
            noWrap: true,
            tms: false,
        });

        tileLayer.addTo(this.$parent.mapObject);
    },
    render() {
        return null;
    }
};

export default {
    components: { LMap, CustomTileLayer, LFeatureGroup },

    async mounted() {
        // await this.fetchAlarms();
        // await this.fetchAndCountAlarmsAnswers();
        await this.fetchContours();
        await this.fetchRectanglesMpp();
        try {
            api.get_layout_model_global_info(this.installation_id).then((res) => {
                this.markerLatLng = [res.data.latitude, res.data.longitude]
            })
        }
        catch {
            const res = (await backend.get_install_form(this.installation_id)).data

            const description = res.description
            this.markerLatLng = [parseFloat(description.markerLatLng0), parseFloat(description.markerLatLng1)]
        }
        try {

            let corners = (await backend.get_mask_install(this.installation_id)).data
            let fileURL = URL.createObjectURL((await backend.get_mask_file_install(this.installation_id)).data)

            const map = this.$refs.refMap.mapObject

            const options = {
                corners: corners,
                suppressToolbar: true,
                editable: false,
                actions: [],
                mode: ''
            }

            this.overlay = L.distortableImageOverlay(fileURL, options).addTo(map)
            this.imageExiste = true
        }
        catch (error) {
            console.error("Pas d'image à recuperer")
        }
        try {
            this.datas=(await backend.get_visudatas(this.installation_id)).data
        } catch (error) {
            console.error("Pas de données à visualiser pour cet audit", this.installation_id)
        }


    },

    data() {
        return {
            datas: [],
            typeDonnes: -1,
            installation_id: this.$route.params.id,
            highlightedMpp: this.$route.params.highlightMpp,
            url: "http://{s}.tile.osm.org/{z}/{x}/{y}.png",
            zoom: 17,
            markerLatLng: [0, 0],
            center: [48.866667, 2.333333],
            mapRef: null,
            bounds: null,

            tileProviders:
            {
                url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}.png",
                visible: true,
                name: "satelliteESRI",
                attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
            },

            mpps: [],
            polygonCoords: [],
            rectangles: [],
            mpp_assigned: [],
            modalState: false,
            alarmsJSON: [],
            selectedBlockAlarm: [],
            alarmsAnswersJSON: [],
            selectedBlockAnswer: [],
            todos: 0,
            pendings: 0,
            creerAlarme: false,

        };
    },


    watch: {
        typeDonnes() {
           this.$refs.featureGroup.mapObject.eachLayer(polygone => {
        polygone.setStyle(this.getStylePolygon(polygone))
      })
            this.$forceUpdate();
        },
        isLoaded() {
            this.$forceUpdate();
        },
    },


    methods: {
        async fetchContours() {
            try {
                const response = await backend.get_edges_install(this.installation_id);
                this.polygonCoords = response.data;
                await this.$nextTick();

            } catch (err) {
                console.error("Pas de données géospatiale pour ce site")
            }
        },

        async fetchRectanglesMpp() {
            try {
                const [response1, response2] = await Promise.all([backend.get_blocs_install(this.installation_id), backend.get_m_pts_install(this.installation_id)]);
                this.rectangles = response1.data;
                this.mpp_assigned = response2.data;

                await this.$nextTick();

            } catch (err) {
                this.rectangles = [];
                this.mpp_assigned = [];
            }
            this.initPolygons();
        },


        initPolygons() {
            const poly = L.polygon(this.polygonCoords);
            this.$refs.refMap.mapObject.fitBounds(poly.getBounds());
            this.rectangles.forEach((rectangle, index) => {
                this.addPolygonToLayer(rectangle, this.mpp_assigned[index]);
            });
        },

        refresHeader() {
        },
        zoomUpdated(zoom) {
            this.zoom = zoom;
        },
        centerUpdated(center) {
            this.center = center;
        },
        boundsUpdated(bounds) {
            this.bounds = bounds;
        },



        addPolygonToLayer(rectangle, mpp) {
            const polygon = L.polygon(rectangle);
            polygon.options.mpp = mpp;
            polygon.on('click', () => {
                this.openModal(polygon);
            });
            polygon.setStyle(this.getStylePolygon(polygon));
            this.$refs.featureGroup.mapObject.addLayer(polygon);
        },

        getAnswerIndex(alarmId) {

            for (var answer in this.alarmsAnswersJSON) {
                if (this.alarmsAnswersJSON[answer].id === alarmId) {
                    return answer
                }
            }
        },
        closeModal() {
            this.modalState = false;
        },

        getStylePolygon(layer) {
            let color
            if (this.typeDonnes === -1)
                color = "#FFFFFF"

            else {
                let valeur = -1
                layer.options.mpp.forEach(element => {
                    this.datas[this.typeDonnes].values.forEach(val => {
                        if (val.mpp === element && val.valeur > valeur)
                            valeur = val.valeur
                    })
                })
                this.datas[this.typeDonnes].levels.forEach(seuil => {
                    if (seuil.valeurMin === 0 && valeur === 0) {
                        color = seuil.couleur
                    }
                    else {
                        if (valeur > seuil.valeurMin && valeur <= seuil.valeurMax) {
                            color = seuil.couleur
                        }
                    }
                    if (color === undefined) {
                        color = "#FFFFFF"
                    }
                })
            }



            return {
                color: color,
                fillColor: color,
                fillOpacity: 0.7,
            }

        },

        onLocationFound(e) {
            var radius = e.accuracy;

            L.circleMarker(e.latlng, {
                radius: 7,           // en pixels
                color: '#00C51D',
                fillColor: '#00C51D',
                fillOpacity: 1
            }).addTo(this.$refs.refMap.mapObject)

            L.circle(e.latlng, {
                radius: radius,
                color: '#00C51D',
                fillColor: '#00C51D',
                opacity: 0.3,
                fillOpacity: 0.1
            }).addTo(this.$refs.refMap.mapObject);
        },

        onLocationError(e) {
            alert(e.message);
        },

        toggleAlarmCreate() {
            this.creerAlarme = !this.creerAlarme
        }
    }
};
</script>

<style scoped>
.small-map {
    height: 100%;
    width: 100%;
    aspect-ratio: 1 / 1;
    z-index: 0;
}

.container {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    height: 90vh;
    justify-content: center;
    /* align-content: center; */
}

.button {
    max-width: 30%;
    margin-left: 5%;
    margin-top: 3%;
    margin-right: 0;
    height: fit-content;
    background-color: #d9d9d9;
}

.mapContainer {
    display: flex;

    height: 80%;
    width: 100%;
    margin-top: 2%;

}

.text-box {
    width: 60%;
    margin-left: 5%;
    margin-top: 3%;
    /* background-color: rgb(169, 117, 218); */
    box-sizing: border-box;
    height: fit-content;

}

.liste {
    list-style: circle;
}

.rondJaune {
    background-color: #FFE97C;
    display: inline-flex;
    /* float: right; */
    margin-right: 2%;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    justify-content: center;
}

.rondRouge {
    background-color: #CF0000;
    display: inline-flex;
    /* float: right; */
    margin-right: 2%;
    height: 25px;
    width: 25px;
    border-radius: 50%;
    justify-content: center;
}
</style>